import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioSnrs2 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS2: TIdToPageConfigMap = {
  [PageIdStylioSnrs2.AGE_SNRS2]: {
    id: PageIdStylioSnrs2.AGE_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioSnrs2.URGE_SNRS2]: {
    id: PageIdStylioSnrs2.URGE_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.HAIR_COLOR_SNRS2]: {
    id: PageIdStylioSnrs2.HAIR_COLOR_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.EYES_COLOR_SNRS2]: {
    id: PageIdStylioSnrs2.EYES_COLOR_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.JEWELRY_SNRS2]: {
    id: PageIdStylioSnrs2.JEWELRY_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.BODY_SHAPE_SNRS2]: {
    id: PageIdStylioSnrs2.BODY_SHAPE_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.STYLIO_TO_HELP_SNRS2]: {
    id: PageIdStylioSnrs2.STYLIO_TO_HELP_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.TALL_SNRS2]: {
    id: PageIdStylioSnrs2.TALL_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.WEIGHT_SNRS2]: {
    id: PageIdStylioSnrs2.WEIGHT_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.URGE_2_SNRS2]: {
    id: PageIdStylioSnrs2.URGE_2_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.SHOPPING_SNRS2]: {
    id: PageIdStylioSnrs2.SHOPPING_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.STYLE_MOST_MATTERS_SNRS2]: {
    id: PageIdStylioSnrs2.STYLE_MOST_MATTERS_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.FAVORITE_COLORS_SNRS2]: {
    id: PageIdStylioSnrs2.FAVORITE_COLORS_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_1]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_1,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_2]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_3]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_3,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_4]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_4,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_5]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_5,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_6]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_6,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_7]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_7,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_8]: {
    id: PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_8,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.STYLES_FEEL_LIKE_YOU_SNRS2]: {
    id: PageIdStylioSnrs2.STYLES_FEEL_LIKE_YOU_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.URGE_4_SNRS2]: {
    id: PageIdStylioSnrs2.URGE_4_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.BRAND_SNRS2]: {
    id: PageIdStylioSnrs2.BRAND_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.FIND_NEW_CLOTHES_SNRS2]: {
    id: PageIdStylioSnrs2.FIND_NEW_CLOTHES_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.NOTHING_TO_WEAR_SNRS2]: {
    id: PageIdStylioSnrs2.NOTHING_TO_WEAR_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.OLD_CLOTHES_SNRS2]: {
    id: PageIdStylioSnrs2.OLD_CLOTHES_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.COMBINE_CLOTHES_SNRS2]: {
    id: PageIdStylioSnrs2.COMBINE_CLOTHES_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.OUTFIT_LOOK_SNRS2]: {
    id: PageIdStylioSnrs2.OUTFIT_LOOK_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.OPTIMIZE_BUDGET_SNRS2]: {
    id: PageIdStylioSnrs2.OPTIMIZE_BUDGET_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.EVERYDAY_LIFESTYLE_SNRS2]: {
    id: PageIdStylioSnrs2.EVERYDAY_LIFESTYLE_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.CLIMAT_SNRS2]: {
    id: PageIdStylioSnrs2.CLIMAT_SNRS2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs2.URGE_3_SNRS2]: {
    id: PageIdStylioSnrs2.URGE_3_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.PREPARE_FLOW_SNRS2]: {
    id: PageIdStylioSnrs2.PREPARE_FLOW_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.EMAIL_SNRS2]: {
    id: PageIdStylioSnrs2.EMAIL_SNRS2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs2.SUBSCRIPTIONS_SNRS2]: {
    id: PageIdStylioSnrs2.SUBSCRIPTIONS_SNRS2,
  },
  [PageIdStylioSnrs2.CANCEL_OFFER_SNRS2]: {
    id: PageIdStylioSnrs2.CANCEL_OFFER_SNRS2,
  },
  [PageIdStylioSnrs2.SUB_UPSELL_SNRS2]: {
    id: PageIdStylioSnrs2.SUB_UPSELL_SNRS2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrs2.UPSELL_SNRS_2]: {
    id: PageIdStylioSnrs2.UPSELL_SNRS_2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrs2.DOWNLOAD_SNRS2]: {
    id: PageIdStylioSnrs2.DOWNLOAD_SNRS2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
